import { MMPProps } from './types';

const mmpPages: MMPProps[] = [
  {
    route: '/mmp',
    title: 'MMP Start',
    text: 'Start a new MMP assessment.',
    decisionList: [
      {
        id: '1',
        text: 'Start',
        variant: 'success',
        navigateTo: '/mmp_housebound',
      },
    ],
  },
  {
    route: '/mmp_housebound',
    title: 'MMP Housebound Status',
    text: 'Is the patient coded housebound.',
    decisionList: [
      {
        id: '1',
        text: 'Yes',
        navigateTo: '/mmp_housebound_yes',
      },
      {
        id: '2',
        text: 'No',
        navigateTo: '/mmp_vision',
      },
    ],
  },
  {
    route: '/mmp_housebound_yes',
    title: 'GP MMP Slot',
    text: 'Put to GP MMP slot for advice and take own Reception action in 1 week to follow up.',
    decisionList: [
      {
        id: '1',
        text: 'Start a New MMP Assessment',
        variant: 'success',
        navigateTo: '/mmp_housebound',
      },
    ],
  },
  {
    route: '/mmp_vision',
    title: 'MMP Vision Check',
    text: 'Check the vision guidelines to see if MMP has been completed in the last 3 months.',
    decisionList: [
      {
        id: '1',
        text: 'MMP completed',
        navigateTo: '/mmp_yes',
      },
      {
        id: '2',
        text: 'MMP has not been completed',
        navigateTo: '/mmp_no',
      },
    ],
  },
  {
    route: '/mmp_yes',
    title: 'Update Vision Guidelines',
    text: "Goto Vision Guidelines, click MMP Button, type MMP, add each disease and confirm what's happened.",
    decisionList: [
      {
        id: '1',
        text: 'Start a New MMP Assessment',
        variant: 'success',
        navigateTo: '/mmp_housebound',
      },
    ],
  },
  {
    route: '/mmp_no',
    title: 'Identify Patient Conditions',
    text: "<div><p>Go to <b>Vision Patient Groups</b>:</p> <ol><li>Find MMP Month and year you're looking at.</li><li>Click blue button.</li><li>FindS patient to check with Priority ones.</li></ol></div>",
    decisionList: [
      {
        id: '1',
        text: 'Next',
        navigateTo: '/conditions',
      },
    ],
  },
];

export { mmpPages };
